import { createAction } from '../../services';
export const SET_BLOG_DATA = 'appData/SET';
export const setAppData = createAction(SET_BLOG_DATA);
export const FETCH_BLOG_DATA_REQUEST = 'appData/FETCH_REQUEST';
export const FETCH_BLOG_DATA_SUCCESS = 'appData/FETCH_SUCCESS';
export const FETCH_BLOG_DATA_FAILURE = 'appData/FETCH_FAILURE';
export const fetchAppDataRequest = () => ({ type: FETCH_BLOG_DATA_REQUEST });
export const fetchAppDataSuccess = (payload) => ({
    type: FETCH_BLOG_DATA_SUCCESS,
    payload,
});
export const fetchAppDataFailure = () => ({ type: FETCH_BLOG_DATA_FAILURE });
export function fetchAppData(promise) {
    return (dispatch, _getState, { request }) => {
        dispatch(fetchAppDataRequest());
        promise ||= request.metered
            ? request.metered('/_api/blogs/this')('/_api/blogs/this')
            : request('/_api/blogs/this');
        return promise
            .then((appData) => dispatch(fetchAppDataSuccess(appData)), () => dispatch(fetchAppDataFailure()))
            .then(() => promise);
    };
}
//# sourceMappingURL=app-data-actions.js.map